export default class Header {
    init(): void {
        this.menuBurger()
        this.navClass()
    }

    menuBurger(): void {
        const menu = document.querySelector('#banner')
        const menuButton = document.querySelector('.menu')

        menuButton &&
            menuButton.addEventListener('click', function () {
                menu && menu.classList.toggle('open')
            })
    }

    navClass(): void {
        let scrollpos = window.scrollY
        const banner = document.querySelector('.banner')
        const header = document.querySelector('header')

        if (header instanceof HTMLElement && banner instanceof HTMLElement) {
            // const headerHeight = header.offsetHeight
            // const bannerHeight = banner.offsetHeight
            const addClassOnScroll = () => banner.classList.add('banner-fixed')
            const removeClassOnScroll = () => banner.classList.remove('banner-fixed')

            window.addEventListener('scroll', (): void => {
                scrollpos = window.scrollY
                // if (scrollpos >= headerHeight - bannerHeight) {
                if (scrollpos >= 100) {
                    addClassOnScroll()
                } else {
                    removeClassOnScroll()
                }
            })
        }
    }
}
